import { render } from "./SpinnerOverlay.vue?vue&type=template&id=11236048&scoped=true"
import script from "./SpinnerOverlay.vue?vue&type=script&lang=js"
export * from "./SpinnerOverlay.vue?vue&type=script&lang=js"

import "./SpinnerOverlay.vue?vue&type=style&index=0&id=11236048&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11236048"]])

export default __exports__